import React, {useContext, useEffect, useState} from "react";
import styles from "./PageInformation.module.css";
import { useParams } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Spin from "../../components/UI/Spin/Spin";
import ServerService from "../../service/ServerService";
import {fillTextPage} from "../../Utils/FillTextPage";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";

function PageInformation() {
    const { id } = useParams();
    const [loadingPage, setLoadingPage] = useState(true);
    const [data, setData] = useState({});
    const lang_id = localStorage.getItem("lang")?localStorage.getItem("lang"):"ru";
    const {store} = useContext(Context)
    useEffect(()=>{
        fillTextPage("pageInf",store)
    })
    async function get_data() {
        try {
            const response = await ServerService.get_footer_text(id);

            // Заменяем все вхождения "\n\n", "\r\n\r\n" на "<br>"
            //console.log(response.data.data,"dta")
            let formattedText =  response.data.data["ru"].replace(/\r\n\r\n|\n\n|\r\r/g, "<br>");

            formattedText = response.data.data["ru"].replace(/\r\n|\n|\r/g, "<br>");

            setData({ ...response.data.data, text: formattedText });
            setLoadingPage(false);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        get_data();
    }, []);

    if (loadingPage) {
        return <Spin />;
    }

    return (
        <>
            <div className={styles.mainContainer}>
                <div className={styles.header}>{data.name}</div>
                <div className={styles.main}>
                    {/* Теперь текст будет содержать HTML-теги для переноса строки */}
                    <p dangerouslySetInnerHTML={{ __html: data.text }}></p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default observer(PageInformation);
